export default __webpack_public_path__ + "static/media/monstera-leaf.6ce7c0c5.png";